import { useMemo } from 'react';
import { filterRoutesByFeatureFlags, getFeatureFlagKeys } from '@/navigation/routes/routeFlags';
import { useFeatureFlags } from './useFeatureFlags';
import type { AppRouteDefinition } from '@/navigation/routes/routes';
import type { FeatureFlagResolveResult } from '@/shared/data/featureFlags';

type UseAppFeatureFlagsArgs = {
  routes: AppRouteDefinition[];
  token: string | null;
  userId: string | null;
};

export const useAppFeatureFlags = ({
  routes,
  token,
  userId,
}: UseAppFeatureFlagsArgs): {
  routeDefinitions: AppRouteDefinition[];
  featureFlags: FeatureFlagResolveResult['flags'] | null;
  featureFlagsLoading: boolean;
} => {
  const featureFlagKeys = useMemo(() => getFeatureFlagKeys(routes), [routes]);
  const { flags, isLoading } = useFeatureFlags({
    keys: featureFlagKeys,
    token,
    identityKey: userId,
    enabled: token !== null,
    refetchOnWindowFocus: false,
  });
  const routeDefinitions = useMemo(
    () => filterRoutesByFeatureFlags(routes, flags),
    [flags, routes],
  );
  return { routeDefinitions, featureFlags: flags, featureFlagsLoading: isLoading };
};
